var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
var DateSelection = function (props) {
    var executeAction = props.executeAction, slots = props.slots;
    var today = new Date().toISOString().split("T")[0];
    var _a = useState(today), date = _a[0], setDate = _a[1];
    var doAction = function (slotDuration) {
        var tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
        var off = new Date()
            .toLocaleTimeString("en-us", { timeZoneName: "short" })
            .split(" ")
            .pop();
        if (executeAction)
            executeAction("Date: ".concat(date, "\nDuration: ").concat(slotDuration, " minutes"), "Here is the slot duration details:: Date: " +
                date +
                ", Timezone: " +
                tz +
                ", Duration:" +
                slotDuration +
                " minutes");
    };
    return (_jsxs(_Fragment, { children: [_jsx("div", __assign({ className: "chat__messages-form", style: {
                    marginTop: "10px",
                    display: "flex",
                    padding: "0px",
                } }, { children: _jsx("input", { style: { background: "white" }, type: "date", disabled: !executeAction, min: today, placeholder: "Select Date", required: true, value: date, onChange: function (e) { return setDate(e.target.value); }, className: "chat_form-control" }) })), _jsx("div", __assign({ 
                // className="chat__messages-group"
                style: {
                    marginTop: "15px",
                } }, { children: _jsx("ul", __assign({ className: "chat__messages-list multi_choice-list" }, { children: slots === null || slots === void 0 ? void 0 : slots.map(function (slot, index) {
                        return (_jsx("div", __assign({ className: "multi_choice-list-item-btn \n                    ".concat(date && executeAction ? "" : "disabled", "\n               "), onClick: function () { return doAction(slot.duration); } }, { children: _jsx("span", __assign({ className: "actual" }, { children: slot.name })) })));
                    }) })) }))] }));
};
export default DateSelection;
